// accessLevel: 0 = neither, 1 = ATS, 2 = Assessment, 3 = both.
export const getCorporateLandingPath = accessLevel =>
  accessLevel === 2 ? '/v2/dashboard' : '/dashboard'
